import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IndividualClassPerformance from "./routes/IndividualClassPerformance";
export default store => {
  return {
    path: "class",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "class" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [IndividualClassPerformance(store)],
  };
};
